import React from 'react'
import Svg from '../../../components/Svg/Svg'
import { SvgProps } from '../../../components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
<g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
stroke="none">
<path d="M68 204 c-16 -8 -28 -19 -28 -24 0 -14 14 -12 28 2 10 10 15 10 22
-2 9 -13 11 -13 20 0 9 13 11 13 20 0 9 -13 11 -13 20 0 7 12 12 12 22 2 14
-14 28 -16 28 -2 0 14 -55 40 -82 40 -13 -1 -35 -8 -50 -16z"/>
<path d="M16 123 c9 -37 13 -41 24 -23 7 10 10 11 10 3 0 -26 18 -12 22 17 3
17 1 30 -4 30 -4 0 -8 -6 -8 -12 0 -8 -3 -9 -8 -3 -4 6 -15 11 -25 13 -15 3
-17 -2 -11 -25z"/>
<path d="M91 135 c-1 -25 10 -40 29 -40 19 0 30 14 30 40 0 15 -2 17 -9 6 -7
-11 -9 -11 -14 0 -5 12 -7 12 -15 0 -8 -11 -10 -11 -15 0 -3 9 -6 7 -6 -6z"/>
<path d="M168 120 c4 -29 22 -43 22 -17 0 8 3 7 10 -3 11 -18 15 -14 24 23 6
23 4 28 -11 25 -10 -2 -21 -7 -25 -13 -5 -6 -8 -5 -8 3 0 6 -4 12 -8 12 -5 0
-7 -13 -4 -30z"/>
<path d="M40 60 c0 -13 54 -40 80 -40 26 0 80 27 80 40 0 14 -14 12 -28 -2
-10 -10 -15 -10 -22 2 -9 13 -11 13 -20 0 -9 -13 -11 -13 -20 0 -9 13 -11 13
-20 0 -7 -12 -12 -12 -22 -2 -14 14 -28 16 -28 2z"/>
</g>
    </Svg>
  )
}

export default Icon
